"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVariantsProducts = exports.useAtrributes = exports.useCategoryDetails = exports.useOrdersByUser = exports.useOrderDetails = exports.useUserDetails = exports.useShopDetails = exports.useProductList = exports.useProductDetails = void 0;
const useQuery_1 = require("./useQuery");
exports.useProductDetails = useQuery_1.queryWithVariablesFactory("getProductDetails");
exports.useProductList = useQuery_1.queryWithVariablesFactory("getProductList");
exports.useShopDetails = useQuery_1.queryFactory("getShopDetails");
exports.useUserDetails = useQuery_1.queryFactory("getUserDetails");
exports.useOrderDetails = useQuery_1.queryWithVariablesFactory("getOrderDetails");
exports.useOrdersByUser = useQuery_1.queryWithVariablesFactory("getOrdersByUser");
exports.useCategoryDetails = useQuery_1.queryWithVariablesFactory("getCategoryDetails");
exports.useAtrributes = useQuery_1.queryWithVariablesFactory("getAttributes");
exports.useVariantsProducts = useQuery_1.queryWithVariablesFactory("getVariantsProducts");
//# sourceMappingURL=queries.js.map